import { IAccordionWidgetData } from "./accordion-widget-data";
import { IAnimationData } from "./animation-data";
import { IBlogPostWidgetData } from "./blog-post-widget-data";
import { IBlogRollWidgetData } from "./blog-roll-widget-data";
import { IBlogSubscribeWidgetData } from "./blog-subscribe-widget-data";
import { IBoxWidgetData } from "./box-widget-data";
import { IBreadcrumbsWidgetData } from "./breadcrumbs-widget-data";
import { IButtonStyles, IHoveredButtonStyles } from "./button-styles";
import { IButtonWidgetData } from "./button-widget-data";
import { IBuyButtonWidgetData } from "./buy-button-widget-data";
import { ICalendarEventDetailsWidgetData } from "./calendar/calendar-event-details-widget-data";
import { IChatWidgetData } from "./chat-widget-data";
import { ICheckoutWidgetData } from "./checkout-widget-data";
import { ICookiesButtonWidgetData } from "./cookies-button-widget-data";
import { ICopyrightWidgetData } from "./copyright-widget-data";
import { ICountdownWidgetData } from "./countdown-widget-data";
import { IDividerWidgetData } from "./divider-widget-data";
import { IEmbedWidgetData } from "./embed-widget-data";
import { IErrorSectionData } from "./error-section-data";
import { IFacebookLikeWidgetData } from "./facebook-like-widget-data";
import { IFontData } from "./font-data";
import { IFooterSectionData } from "./footer-data";
import { IFormWidgetData } from "./form-widget-data";
import { IGalleryWidgetData } from "./gallery-widget-data";
import { IGdprRequestWidgetData } from "./gdpr/gdpr-request-widget-data";
import { IDesktopHeaderSectionData, IMobileHeaderSectionData } from "./header-data";
import { IImageWidgetData } from "./image-widget-data";
import { ILinkFontData } from "./link-data";
import { ILogoWidgetData } from "./logo-widget-data";
import { IMapWidgetData } from "./map-widget-data";
import { IMenuWidgetData } from "./menu-data";
import { IMeshColumnData, IMeshData, IMeshRowData } from "./mesh-data";
import { IMeshSectionData } from "./mesh-section-data";
import { IMyOrdersWidgetData } from "./my-orders-widget-data";
import { IPageBackgroundData } from "./pages-background-data";
import { IPaypalWidgetData } from "./paypal-widget-data";
import { IPopUpData, IPopUpSectionData } from "./pop-up-data";
import { IPricingTableWidgetData } from "./pricing-table-widget-data";
import { ISearchBarWidgetData } from "./search-bar-widget-data";
import { ISearchResultsWidgetData } from "./search-results-widget-data";
import { IFooterSectionsAreaData, IHeaderSectionsAreaData, IMainSectionsAreaData } from "./section-area-data";
import { ILiteHeaderSectionData } from "./lite-header-section-data";
import { ISocialLinksWidgetData } from "./social-links-widget-data";
import { ISpacerWidgetData } from "./spacer-widget-data";
import { IStoreOrderDetailsWidgetData } from "./store-order-details-widget-data";
import { IStoreSubscriptionDetailsWidgetData } from "./store-subscription-details-data";
import { IStoreSubscriptionsWidgetData } from "./store-subscriptions-widget-data";
import { IStripeCheckoutWidgetData } from "./stripe-checkout-widget-data";
import { ITextWidgetData } from "./text-widget-data";
import { ITruFormWidgetData } from "./truform-widget-data";
import { IVideoWidgetData } from "./video-widget-data";
import { ILoginWidgetData } from "./website-members/login-widget-data";
import { IMemberMenuWidgetData } from "./website-members/member-menu-widget-data";
import { IRecoveryWidgetData } from "./website-members/recovery-widget-data";
import { IRegisterWidgetData } from "./website-members/register-widget-data";
import { IResetPasswordWidgetData } from "./website-members/reset-password-widget-data";
import { IStoreOrderConfirmationWidgetData } from "./store-order-confirmation-widget-data";
import { ICalendarEventListWidgetData } from "./calendar/calendar-event-list-widget-data";
import { ICalendarAppointmentScheduleWidgetData } from "./calendar/calendar-appointment-schedule-widget-data";

export * from "./accordion-widget-data";
export * from "./animation-data";
export * from "./background-data";
export * from "./blog-integration-data";
export * from "./blog-post-widget-data";
export * from "./blog-roll-widget-data";
export * from "./blog-subscribe-widget-data";
export * from "./border-data";
export * from "./box-widget-data";
export * from "./button-widget-base-data";
export * from "./button-widget-data";
export * from "./buy-button-widget-data";
export * from "./chat-widget-data";
export * from "./cookies-button-widget-data";
export * from "./copyright-widget-data";
export * from "./countdown-widget-data";
export * from "./divider-widget-data";
export * from "./embed-widget-data";
export * from "./facebook-like-widget-data";
export * from "./font-data";
export * from "./footer-data";
export * from "./form-widget-base-data";
export * from "./form-widget-data";
export * from "./form-widget-style-data";
export * from "./gallery-widget-data";
export * from "./gdpr/gdpr-request-widget-data";
export * from "./header-data";
export * from "./height-data";
export * from "./image-widget-data";
export * from "./link-data";
export * from "./link-style-data";
export * from "./map-widget-data";
export * from "./menu-data";
export * from "./mesh-data";
export * from "./mesh-section-data";
export * from "./my-orders-widget-data";
export * from "./page-builder";
export * from "./page-content-rendering";
export * from "./page-data";
export * from "./pages-background-data";
export * from "./paypal-widget-data";
export * from "./pb.scripts.service";
export * from "./pop-up-builder";
export * from "./pop-up-data";
export * from "./pop-up-page-content-rendering";
export * from "./position-data";
export * from "./pricing-table-widget-data";
export * from "./search-bar-widget-data";
export * from "./search-results-widget-data";
export * from "./section-base-data";
export * from "./site-store/store-product-data";
export * from "./social-links-widget-data";
export * from "./spacer-widget-data";
export * from "./store-order-details-widget-data";
export * from "./store-subscription-details-data";
export * from "./store-subscriptions-widget-data";
export * from "./store-order-confirmation-widget-data";
export * from "./stripe-checkout-widget-data";
export * from "./subscribe-widget-data";
export * from "./text-widget-data";
export * from "./truform-widget-data";
export * from "./video-widget-data";
export * from "./logo-widget-data";
export * from "./website-members/login-widget-data";
export * from "./website-members/member-menu-widget-data";
export * from "./website-members/recovery-widget-data";
export * from "./website-members/register-widget-data";
export * from "./website-members/reset-password-widget-data";
export * from "./website-members/members-area-widget-container-style";
export * from "../services/translate.service";
export * from "./breadcrumbs-widget-data";
export * from "./calendar/calendar-appointment-schedule-widget-data";
export * from "./calendar/calendar-event-details-widget-data";
export * from "./calendar/calendar-event-list-widget-data";
export * from "./checkout-pages-settings-data";
export * from "./checkout-widget-data";
export * from "./lite-header-section-data";

export interface ICopyOptions {
    type: SectionType;
    source: "Section" | "SectionTemplate";
    context: ISectionCreationContext;
    copyName?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ISectionCreationContext extends ICreationContextBase {
}

export interface IWidgetCreationContext extends ICreationContextBase {
    placeType?: WidgetPlaceType;
}

export interface ICreationContextBase {
    callerId?: string;
    direction?: Direction | null;
    busyFormIds?: string[];
}

export interface IMovingContext {
    widgetData: IElementData;

    widgetColSize: number;
    fromPosition: IWidgetPosition;

    destinationSectionId: string;
    destinationMeshId: string;
    destinationId: string;

    direction?: Direction | null;

    expectedColumnsIds?: string[];
    movingPlace: WidgetMovingPlaceType
}

export type WidgetMovingPlaceType = "section" | "widgetContainer"

export interface IWidgetPosition {
    sectionId: string;
    id: string;
    columnId: string;
    nextWidgetId?: string;
}

export interface IBoxedWidgetPosition extends IWidgetPosition {
    boxWidgetId: string;
}

export interface IWidgetVisibility {
    visibility?: IVisibility | null;
}

export interface IPagePrimaryElement {
    primaryElement: boolean;
}

export interface IVisibility {
    desktop: boolean;
    tablet: boolean;
    mobile: boolean;
}

export interface IResizingByWidthContext {
    widgetId: string;
    direction: Direction;
    addColumnsCount: number; // positive number for expansion, negative for compression
    oldHeightInPx: string;
}

export interface IResizingByHeightContext {
    widgetId: string;
    heightResizeType?: HeightResizeType,
    roundedHeight?: number;
    widgetType?: WidgetType,
    minHeight?: number;
}

export interface IElementInfo {
    id: string;
    data: IElementData;
}

export interface ICommonStyles {
    maxWidthInPx: number;
    baseFontSize: number;
    headerNavigationFont: IFontData;
    paragraphFont: IFontData;
    subheadingFont: IFontData;
    heading1Font: IFontData;
    heading2Font: IFontData;
    heading3Font: IFontData;
    heading4Font: IFontData;
    tableHeaderFont: IFontData;
    tableDataFont: IFontData;
    navigationFont: IFontData;
    listFont: IFontData;
    primaryButtonStyles: IButtonStyles;
    secondaryButtonStyles: IButtonStyles;
    linkStyles: ILinkFontData;
    primaryHoveredButtonStyles: IHoveredButtonStyles;
    secondaryHoveredButtonStyles: IHoveredButtonStyles;
    animation: IAnimationData;
}

export type SelfPosition = "start" | "center" | "end" | "self-start" | "self-end" | "flex-start" | "flex-end" | "top" | "bottom";

export enum Orientation {
    Vertical = "vertical",
    Horizontal = "horizontal"
}

export type IPageElementData = IPageBackgroundData;

export type IElementData = IPopUpData | ISectionsAreaData | ISectionData | IMeshStructureElement | IWidgetData | IPageBackgroundData;

export type ISectionsAreaData = IMainSectionsAreaData | IHeaderSectionsAreaData | IFooterSectionsAreaData;

export type ISectionData = ISectionWithMeshData | ICustomSectionData;

export type ICustomSectionData = IMobileHeaderSectionData | ILiteHeaderSectionData | IErrorSectionData;

export type ISectionWithMeshData = IMeshSectionData | IFooterSectionData | IPopUpSectionData | IDesktopHeaderSectionData

export type ISubscribeWidgetData = IBlogSubscribeWidgetData;

export type IMeshStructureElement = IMeshData | IMeshRowData | IMeshColumnData;

export type IWidgetWithFormData =
    IFormWidgetData |
    ISubscribeWidgetData |
    IRecoveryWidgetData |
    IResetPasswordWidgetData |
    ILoginWidgetData |
    IRegisterWidgetData |
    IGdprRequestWidgetData;

export type IMembersAreaWidgetData = 
    ILoginWidgetData |
    IRegisterWidgetData |
    IRecoveryWidgetData |
    IResetPasswordWidgetData;

export type IWidgetData =
    IImageWidgetData |
    ITextWidgetData |
    IVideoWidgetData |
    ISpacerWidgetData |
    IDividerWidgetData |
    IButtonWidgetData |
    ICountdownWidgetData |
    IWidgetWithFormData |
    IPaypalWidgetData |
    IFacebookLikeWidgetData |
    IStripeCheckoutWidgetData |
    IEmbedWidgetData |
    IChatWidgetData |
    IMenuWidgetData |
    IBreadcrumbsWidgetData |
    IBlogRollWidgetData |
    IBlogPostWidgetData |
    ISocialLinksWidgetData |
    IBoxWidgetData |
    IMapWidgetData |
    IAccordionWidgetData |
    IMyOrdersWidgetData |
    IRegisterWidgetData |
    ILoginWidgetData |
    IGalleryWidgetData |
    IRecoveryWidgetData |
    IMemberMenuWidgetData |
    IResetPasswordWidgetData |
    ITruFormWidgetData |
    IGdprRequestWidgetData |
    ICookiesButtonWidgetData |
    ISearchBarWidgetData |
    ISearchResultsWidgetData |
    ICopyrightWidgetData |
    IBuyButtonWidgetData |
    IStoreSubscriptionsWidgetData |
    IStoreSubscriptionDetailsWidgetData |
    IStoreOrderConfirmationWidgetData |
    ICheckoutWidgetData |
    IStoreOrderDetailsWidgetData |
    IPricingTableWidgetData |
    ILogoWidgetData |
    ICalendarEventListWidgetData |
    ICalendarEventDetailsWidgetData |
    ICalendarAppointmentScheduleWidgetData;

export type Direction = "Up" | "Down" | "Right" | "Left" | "Right-Down" | "Left-Down";

export type SectionAreaType = "HeaderSectionsArea" | "MainSectionsArea" | "FooterSectionsArea";
export type SectionType =
    "MeshSection" |
    "HeaderMobileSection" |
    "HeaderDesktopSection" |
    "FooterSection" |
    "PopUpSection" |
    "CheckoutHeaderSection" |
    "LiteHeaderSection" |
    "ErrorSection";

export type WidgetType =
    "ImageWidget" |
    "TextWidget" |
    "VideoWidget" |
    "SpacerWidget" |
    "DividerWidget" |
    "ButtonWidget" |
    "CountdownWidget" |
    "FormWidget" |
    "SubscribeWidget" |
    "PaypalWidget" |
    "FacebookLikeWidget"|
    "StripeCheckoutWidget" |
    "ChatWidget" |
    "EmbedWidget" |
    "MenuWidget" |
    "BlogRollWidget" |
    "BlogPostWidget" |
    "SocialLinksWidget" |
    "BoxWidget" |
    "MapWidget" |
    "AccordionWidget" |
    "MyOrdersWidget" |
    "RegisterWidget" |
    "LoginWidget" |
    "RecoveryWidget" |
    "GalleryWidget" |
    "MemberMenuWidget" |
    "ResetPasswordWidget" |
    "TruFormWidget" |
    "GdprRequestWidget" |
    "CookiesButtonWidget" |
    "SearchBarWidget" |
    "SearchResultsWidget" |
    "CopyrightWidget" |
    "BuyButtonWidget" |
    "StoreSubscriptionsWidget" |
    "StoreSubscriptionDetailsWidget" |
    "StoreOrderDetailsWidget" |
    "StoreOrderConfirmationWidget" |
    "CheckoutWidget" |
    "PricingTableWidget" |
    "LogoWidget" |
    "BreadcrumbsWidget" |
    "CalendarEventListWidget" |
    "CalendarEventDetailsWidget" |
    "CalendarAppointmentScheduleWidget";

export type ElementType = "PopUp" | "PageBackground" | SectionAreaType | SectionType | MeshElementType | WidgetType;

export type MeshElementType = "Mesh" | "MeshRow" | "MeshColumn";

export type WidgetPlaceType = "Section" | "BoxWidget";

export type WidgetFitMode = "contain" | "cover";

export const DEFAULT_COMMON_STYLES: ICommonStyles = {
    maxWidthInPx: 1140,
    baseFontSize: 16,
    navigationFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans"
    },
    headerNavigationFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans"
    },
    paragraphFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans"
    },
    tableHeaderFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans"
    },
    tableDataFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans"
    },
    subheadingFont: {
        color: "#202020",
        size: "1.2rem",
        weight: "700",
        lineHeight: "1.8em",
        letterSpacing: "0em",
        family: "Open Sans"
    },
    heading1Font: {
        color: "#202020",
        size: "3rem",
        weight: "400",
        lineHeight: "1.4em",
        letterSpacing: "0em",
        family: "Open Sans"
    },
    heading2Font: {
        color: "#202020",
        size: "2.5rem",
        weight: "400",
        lineHeight: "1.4em",
        letterSpacing: "0em",
        family: "Open Sans"
    },
    heading3Font: {
        color: "#202020",
        size: "2rem",
        weight: "400",
        lineHeight: "1.4em",
        letterSpacing: "0em",
        family: "Open Sans"
    },
    heading4Font: {
        color: "#202020",
        size: "1.5rem",
        weight: "400",
        lineHeight: "1.4em",
        letterSpacing: "0em",
        family: "Open Sans"
    },
    listFont: {
        color: "#202020",
        size: "1rem",
        weight: "400",
        lineHeight: "1.5em",
        letterSpacing: "0.01em",
        family: "Open Sans",
        paddingInlineStart: "2.5em"
    },
    primaryButtonStyles: {
        font: {
            color: "#ffffff",
            size: "1.1rem",
            weight: "400",
            lineHeight: "1.5em",
            letterSpacing: "0em",
            family: "Open Sans",
            textIndent: "0em"
        },
        fillingColor: "#888888",
        borderColor: "#888888",
    },
    secondaryButtonStyles: {
        font: {
            color: "#202020",
            size: "1.1rem",
            weight: "400",
            lineHeight: "1.5em",
            letterSpacing: "0em",
            family: "Open Sans",
            textIndent: "0em"
        },
        fillingColor: "#DBDBDB",
        borderColor: "#DBDBDB",
    },
    primaryHoveredButtonStyles: {
        textColor: "#ffffff",
        fillingColor: "#888888",
        borderColor: "#888888"
    },
    secondaryHoveredButtonStyles: {
        textColor: "#202020",
        fillingColor: "#DBDBDB",
        borderColor: "#DBDBDB"
    },
    linkStyles: {
        font: {
            color: "#3B507D",
            size: "1rem",
            weight: "400",
            lineHeight: "1.5em",
            letterSpacing: "0.01em",
            family: "Open Sans",
            textIndent: "0em"
        },
        hoveredColor: "#12A3F8",
        visitedColor: "#6C3B7D"
    },
    animation: {
        name: "none",
        duration: 1
    }
};

export const DEFAULT_PAGE_BACKGROUND: IPageBackgroundData = {
    type: "PageBackground",
    id: "page-background",
    style: {
        color: "#FFFFFF"
    }
};

export class VisibilityData {

    public static defaultData(): IVisibility {
        return {
            desktop: true,
            tablet: true,
            mobile: true
        };
    }

}

export type ImageRatioType = "original" | "thumbnail" | "ratio-16-9" | "ratio-4-3" | "ratio-normal" | "ratio-9-16" | "ratio-3-4";

export type AnimationName = "none" | "fade-in" | "float-in" | "expand-in" | "reveal" | "flip-in";
export type ScrollEffectName = "none" | "parallax" | "reveal" | "zoom-in" | "fade-in" | "pan-left";

export type AnimationSource = "site-design" | "widget";

export type HeightResizeType = "px" | "ratio";
